import React from 'react'
import PropTypes from 'prop-types'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import { GoogleApiWrapper } from 'google-maps-react'
import Select from 'react-select'

import Icon from 'Pods/Shared/Icon/Icon'

export class SearchBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      keywords: props.keywords,
      coordinates: null,
      searchFilter: { label: 'Designer name', value: 'designer_name' },
    }

    this.renderFunc = this.renderFunc.bind(this)
    this.onSearchFilterChange = this.onSearchFilterChange.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleLocationSelect = this.handleLocationSelect.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.keywords !== this.props.keywords) {
      this.setState({ keywords: this.props.keywords })
    }
  }

  handleChange(inputText) {
    this.setState({ keywords: inputText, coordinates: null })
  }

  handleLocationSelect(address) {
    this.setState({ keywords: address })

    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then((latLng) => this.setState({ coordinates: latLng }))
      .catch((error, errorInfo) => {
        this.setState({ coordinates: null })
        window.Sentry.captureException(error, { extra: errorInfo })
      })
  }

  onSearchFilterChange(searchFilter) {
    this.props.onSearchFilterChange(searchFilter.value)
    this.setState({ searchFilter })
  }

  handleSearch(event) {
    event.preventDefault()

    this.props.onSearch({ searchFilter: this.state.searchFilter.value, keywords: this.state.keywords })
  }

  renderFunc({ getInputProps, getSuggestionItemProps, suggestions }) {
    return (
      <div className="location-search location-search--inline">
        <span className="location-search__indicator">
          <Icon type={['fas', 'map-marker-alt']} notSpaced />
        </span>
        <input {...getInputProps({ placeholder: 'Enter location...', className: 'form-control location-search__input' })} />
        <div className="location-search__suggestions">
          {suggestions.map(suggestion => {
            const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item'
            return (
              <div
                {...getSuggestionItemProps(suggestion, { className })}
              >
                <span>{suggestion.description}</span>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  render() {
    const searchFilters = [{
      label: 'Location',
      value: 'location',
    },
    {
      label: 'Designer name',
      value: 'designer_name',
      placeholder: 'Search by designer\'s username or full name...',
    }]

    const currentPlaceholder = searchFilters.find(item => item.value === this.state.searchFilter.value).placeholder

    return (
      <form className="designers-search" onSubmit={this.handleSearch}>
        <div className="designers-search__input">
          {this.state.searchFilter.value === 'location' ? (
            <PlacesAutocomplete
              value={this.state.keywords}
              onChange={this.handleChange}
              onSelect={this.handleLocationSelect}
              highlightFirstSuggestion
            >
              {this.renderFunc}
            </PlacesAutocomplete>
          ) : (
            <input
              type="text"
              name="keywords"
              className="form-control"
              placeholder={currentPlaceholder}
              autoComplete="off"
              value={this.state.keywords}
              onChange={(e) => this.handleChange(e.target.value)}
            />
          )}
        </div>
        <div className="designers-search__actions">
          <Select
            name="search-filter-1"
            value={this.state.searchFilter.value}
            options={searchFilters}
            onChange={this.onSearchFilterChange}
            className="Select-outline Select--dark designers-search__select"
            searchable={false}
            clearable={false}
          />
          <button type="submit" className="btn btn-primary">Search</button>
        </div>
      </form>
    )
  }
}

SearchBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onSearchFilterChange: PropTypes.func.isRequired,
  keywords: PropTypes.string,
  googleMapsApiKey: PropTypes.string,
}

SearchBar.defaultProps = {
  keywords: '',
  googleMapsApiKey: undefined,
}

function LoadingContainer() {
  return <span />
}

export default GoogleApiWrapper((props) => {
  const options = { LoadingContainer }

  if (props.googleMapsApiKey) {
    options.apiKey = props.googleMapsApiKey
  }

  return options
})(SearchBar)
